<template>
  <xr-create
    :loading="loading"
    :title="title"
    @close="close"
    @save="saveClick">
    <!-- <i slot="title-append" class="wk wk-icon-fill-help wk-help-tips" data-type="8" data-id="35" /> -->
    <create-sections title="基本信息">
      <el-form
        ref="crmForm"
        :model="fieldForm"
        :rules="fieldRules"
        :validate-on-rule-change="false"
        class="wk-form"
        label-position="top">
        <wk-form-items
          v-for="(children, index) in fieldList"
          :key="index"
          :field-from="fieldForm"
          :field-list="children"
          :ignore-fields="['customerName']"
          @change="formChange"
        >
          <template slot-scope="{ data }">
            <crm-relative-cell
              v-if="data && data.formType == 'customer'"
              :value="fieldForm[data.field]"
              :disabled="data.disabled"
              relative-type="customer"
              @value-change="otherChange($event, data)"
            />
            <xh-customer-address
              v-else-if="data && data.formType == 'map_address'"
              :value="fieldForm[data.field]"
              @value-change="otherChange($event, data)"
            />
            <div v-else-if="data.field == 'customerName'">
              <business-info-input
                v-if="canUseEnterprise"
                v-model="fieldForm[data.field]"
                :maxlength="100"
                :disabled="data.disabled"
                :debounce="1000"
                :type="data.formType"
                value-key="name"
                @select="customerNameSelect"
                @input="formChange(data, index, $event)" />
              <el-input
                v-else
                v-model.trim="fieldForm[data.field]"
                :disabled="data.disabled"
                maxlength="100"
                :placeholder="data.placeholder"
                type="text"
                @input="formChange(data, index, $event)" />
              <el-button
                type="text"
                :disabled="!businessInfo || businessInfo.name !== fieldForm[data.field]"
                class="wk-premium-info-btn"
                data-type="BusinessInformation"
                @click="checkBIDetail">
                <i class="wk wk-icon-lightning-solid wk-premium-info-icon" data-type="BusinessInformation" />
                <span class="wk-premium-info-label" data-type="BusinessInformation">工商信息</span>
              </el-button>
              <div v-if="isExistOtherTenant" class="custom-cross-tenant-tip">
                其他业务线存在类似客户，<span class="custom-cross-tenant-tip-btn" @click="showDataCheck(fieldForm[data.field])">点击查看</span>
              </div>
            </div>
          </template>
        </wk-form-items>
      </el-form>
    </create-sections>

    <el-button
      v-if="action.type == 'save' && contactsSaveAuth"
      slot="footer"
      class="handle-button"
      @click="debouncedSaveField(true)">保存并新建联系人</el-button>

    <!-- 新建 -->
    <contacts-create
      v-if="contactsCreateShow"
      :action="contactsCreateAction"
      @close="close"
      @save-success="close"
    />

    <business-info-view
      v-if="businessInfoViewShow"
      :name="businessInfo.name"
      :form="fieldForm"
      :fields="baseFields"
      @close="businessInfoViewShow = false"
    />
    <!-- 查重 -->
    <DuplicateCheck
      crm-type="customer"
      :visible.sync="dupCheckShow"
      :default-value="customDupDefaultValue" />
  </xr-create>
</template>

<script>
import { filedGetFieldAPI, crmSpecialExamineAPI } from '@/api/crm/common'
import { crmCustomerSaveAPI, crmCustomerTenantCheckAPI } from '@/api/crm/customer'

import XrCreate from '@/components/XrCreate'
import CreateSections from '@/components/CreateSections'
import WkFormItems from '@/components/NewCom/WkForm/WkFormItems'
import { CrmRelativeCell } from '@/components/CreateCom'

import crmTypeModel from '@/wkcrmViews/crm/model/crmTypeModel'
import CustomFieldsMixin from '@/mixins/CustomFields'
import ContactsCreate from '../contacts/Create'
import BusinessInfoInput from '@/components/Premium/BusinessInfo/Input'
import BusinessInfoView from '@/components/Premium/BusinessInfo/View'

import DuplicateCheck from '@/wkcrmViews/crm/components/DuplicateCheck'

import { debounce } from 'throttle-debounce'
import { isEmpty } from '@/utils/types'
import { mapGetters } from 'vuex'
import ExamineMixin from '../mixins/Examine'

export default {
  // 新建编辑
  name: 'CustomerCreate',

  components: {
    XrCreate,
    CreateSections,
    WkFormItems,
    XhCustomerAddress: () => import('@/components/CreateCom/XhCustomerAddress'),
    ContactsCreate,
    CrmRelativeCell,
    BusinessInfoInput,
    BusinessInfoView,
    DuplicateCheck
  },

  mixins: [CustomFieldsMixin, ExamineMixin],

  props: {
    phone: String,
    action: {
      type: Object,
      default: () => {
        return {
          type: 'save',
          id: '',
          data: {}
        }
      }
    }
  },

  data() {
    return {
      loading: false,
      baseFields: [],
      fieldList: [],
      fieldForm: {},
      fieldRules: {},
      contactsCreateAction: {
        type: 'save',
        id: '',
        data: {}
      },
      contactsCreateShow: false,

      // 工商信息
      businessInfo: null,
      businessInfoViewShow: false,
      dupCheckShow: false, // 是否显示客户查重弹窗，新建客户定制化内容
      customDupDefaultValue: '', // 客户查重的名称
      isExistOtherTenant: false // 是否在其他租户有存在相同客户
    }
  },

  computed: {
    ...mapGetters(['crm', 'moduleData']),
    // 如果有次数就可以使用
    canUseEnterprise() {
      if (this.moduleData && Array.isArray(this.moduleData)) {
        const enterprise = this.moduleData.find(item => item.module === 'enterprise')
        return enterprise ? enterprise.number > 0 : false
      }
      return false;
    },
    contactsSaveAuth() {
      return this.crm.contacts && this.crm.contacts.save
    },
    title() {
      return this.action.type === 'update' ? '编辑客户' : '新建客户'
    }
  },

  watch: {},

  created() {
    this.debouncedSaveField = debounce(300, this.saveClick)

    this.getField()
  },

  mounted() {},

  beforeDestroy() {},

  methods: {
    /**
     * 获取数据
     */
    getField() {
      this.loading = true
      const params = {
        label: crmTypeModel.customer
      }

      if (this.action.type == 'update') {
        params.id = this.action.id
      }

      filedGetFieldAPI(params)
        .then(res => {
          const list = res.data || []
          if (!isEmpty(this.phone)) {
            list.forEach(children => {
              children.forEach(item => {
                if (item.formType === 'mobile') {
                  item.defaultValue = this.phone
                }
              })
            })
          }
          const assistIds = this.getFormAssistIds(list)

          const baseFields = []
          const fieldList = []
          const fieldForm = {}
          list.forEach(children => {
            const fields = []
            children.forEach(item => {
              // action.data传入{fieldId:value}的键值对时，覆盖原有值
              this.action.data && this.action.data[item.fieldId] && (item.value = item.defaultValue = this.action.data[item.fieldId] || '')

              const temp = this.getFormItemDefaultProperty(item)
              temp.show = !assistIds.includes(item.formAssistId)

              // 是否可编辑
              const canEdit = this.getItemIsCanEdit(item, this.action.type)
              // 是否禁用
              temp.disabled = !canEdit
              if (params.id && temp.name === '企业状态') {
                // 如果是编辑情况，企业状态字段不可编辑
                temp.disabled = true
                if (this.action.data && this.action.data.specialExamine) {
                  // 发起转精准企业审批
                  item.value = item.defaultValue = '精准企业'
                }
              }
              // 禁止某些业务组件选择
              if (temp.formType == 'customer') {
                if (this.action.type == 'relative') {
                  const relativeDisInfos = {
                    customer: { customer: true },
                    contacts: { customer: true }
                  }

                  // 在哪个类型下添加
                  const relativeTypeDisInfos = relativeDisInfos[this.action.crmType]
                  if (relativeTypeDisInfos) {
                  // 包含的字段值
                    temp.disabled = relativeTypeDisInfos[item.formType] || false
                  }
                }
              }

              // 特殊字段允许多选
              this.getItemRadio(item, temp)

              // 获取默认值
              if (temp.show) {
                fieldForm[temp.field] = this.getItemValue(item, this.action.data, this.action.type)
              }
              fields.push(temp)
              baseFields.push(item)
            })
            fieldList.push(fields)
          })

          this.baseFields = baseFields
          this.fieldList = fieldList
          this.fieldForm = fieldForm
          this.fieldRules = this.getFormRulesByOptionsChange(this.fieldList, this.fieldForm)

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    /**
     * 保存
     */
    saveClick(createContacts = false) {
      this.loading = true
      const crmForm = this.$refs.crmForm
      crmForm.validate(valid => {
        if (valid) {
          const params = this.getSubmiteParams([].concat.apply([], this.fieldList), this.fieldForm)
          this.submiteParams(params, createContacts)
        } else {
          this.loading = false
          // 提示第一个error
          this.getFormErrorMessage(crmForm)
          return false
        }
      })
    },

    /**
     * 提交上传
     */
    submiteParams(params, createContacts) {
      if (this.action.type == 'update') {
        params.entity.customerId = this.action.id
        params.entity.batchId = this.action.batchId
      }

      // 区别是编辑精准还是发起精准
      if (this.action.data && this.action.data.isTrans) {
        params.isTrans = 1 // 1 发起精准审批 0 编辑精准
      } else {
        params.isTrans = 0
      }

      params.entity.brands = params.field.find((item) => item.fieldName === 'brands').value || ''
      params.field = params.field.filter(item => item.fieldName !== 'brands');

      // 相关添加时候的多余提交信息
      if (
        this.action.relativeData &&
        Object.keys(this.action.relativeData).length
      ) {
        params = { ...params, ...this.action.relativeData }
      }
      crmCustomerSaveAPI(params)
        .then(async res => {
          this.loading = false
          this.$store.dispatch('GetMessageNum')
          if (params.field.some(item => (item.name === '企业状态' && item.value === '精准企业'))) {
            crmSpecialExamineAPI({
              businessType: 2, // 业务类型  1 联系人  2 企业
              businessId: res.data ? res.data.customerId : this.action.id
            }).then(async({ data }) => {
              const examine = data.filter(item => item.examineType === 4 && !!item.canInitiate)
              // 接口返回是否需要发起精准联企业审批
              if (examine && examine.length) {
                await this.$confirm('是否发起转精准企业审批?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.postSpecialExamine(examine[0].examineType, { customerIds: res.data.customerId }, examine[0].examineId, res.data.customerName, '', () => {
                    this.submitComplete(res, createContacts, false)
                  })
                }).catch(() => {
                  this.submitComplete(res, createContacts)
                })
              } else {
                this.submitComplete(res, createContacts)
              }
            }).catch(() => {
              this.submitComplete(res, createContacts)
            })
          } else {
            this.submitComplete(res, createContacts)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    submitComplete(res, createContacts, showMessage = true) {
      if (createContacts) {
        this.contactsCreateAction = {
          type: 'relative',
          crmType: 'customer',
          data: {
            customer: res.data || {}
          }
        }
        this.contactsCreateShow = true
      } else {
        showMessage && this.$crmMessage.success(
          this.action.type == 'update' ? '编辑成功' : '添加成功'
        )
        this.close()
      }
      // 保存成功
      this.$emit('save-success', {
        type: 'customer',
        data: res.data || {}
      })
    },

    /**
     * 验证唯一
     */
    UniquePromise({ field, value }) {
      if (field.field === 'customerName') {
        this.getUniquePromise(field, value, this.action).then(() => {
          crmCustomerTenantCheckAPI(value).then((res) => {
            this.isExistOtherTenant = !!res.data.exists
          })
        })
      }
      return this.getUniquePromise(field, value, this.action)
    },

    /**
     * change
     */
    formChange(field, index, value, valueList) {
      if ([
        'select',
        'checkbox'
      ].includes(field.formType) &&
          field.remark === 'options_type' &&
          field.optionsData) {
        const { fieldForm, fieldRules } = this.getFormContentByOptionsChange(this.fieldList, this.fieldForm)
        this.fieldForm = fieldForm
        this.fieldRules = fieldRules
      }
      this.fieldRules = this.getFormRulesByOptionsChange(this.fieldList, this.fieldForm)
    },

    /**
     * 地址change
     */
    otherChange(data, field) {
      this.$set(this.fieldForm, field.field, data.value)
      this.$refs.crmForm.validateField(field.field)
    },

    /**
     * 关闭
     */
    close() {
      this.contactsCreateShow = false
      this.$emit('close')
    },

    /**
     * @description: 客户名称选择
     * @param {*} item 选择的对象
     * @return {*}
     */
    customerNameSelect(item) {
      this.businessInfo = item
    },

    /**
     * @description: 查看工商详情
     * @param {*}
     * @return {*}
     */
    checkBIDetail() {
      if (!this.canUseEnterprise) return
      this.businessInfoViewShow = true
    },

    /**
     * @description 显示客户查重弹窗
     * @param {string} val 客户名称
     */
    showDataCheck(val) {
      this.customDupDefaultValue = val
      this.dupCheckShow = true
    }
  }
}
</script>

<style lang="scss" scoped>
.wk-form {
  /deep/ .el-form-item.is-map_address {
    flex: 0 0 100%;
  }
}

.wk-premium-info-btn {
  position: absolute;
  top: -30px;
  right: 0;
}

.el-autocomplete {
  width: 100%;
}

.custom-cross-tenant-tip {
  padding-top: 4px;
  font-size: 12px;
  line-height: 1;
  color: #ff861d;

  .custom-cross-tenant-tip-btn {
    color: rgb(35, 98, 251);
    cursor: pointer;
  }
}
</style>
